import { cn } from '@/lib/utils';

/**
 * Das Logo, frei stehend – ohne Kachel und ohne Hintergrund.
 *
 * Deshalb zwei Bildfassungen: die Zeichnung ist tannengrün (#315b4e) und hätte
 * auf der dunklen Fläche nur rund 2:1 Kontrast. `logo-dark.png` ist dasselbe
 * Bild mit angehobener Helligkeit (L' = 0.30 + 0.78·L in OKLCH, Farbton und
 * Sättigung unverändert) – die Hell-dunkel-Beziehungen im Bild bleiben so
 * erhalten, nur der dunkelste Ton kommt vom Grund weg. Umgeschaltet wird über
 * CSS, nicht über den Theme-Hook: dann steht schon beim ersten Paint das
 * richtige Bild, ohne Umschaltblitzer.
 *
 * `alt=""` und `aria-hidden`: der Name steht als Text daneben, das Bild würde
 * ihn für Screenreader nur doppeln.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center', className)}>
      <img
        src="/logo.png"
        alt=""
        aria-hidden
        width={320}
        height={320}
        className="size-full object-contain dark:hidden"
      />
      <img
        src="/logo-dark.png"
        alt=""
        aria-hidden
        width={320}
        height={320}
        className="hidden size-full object-contain dark:block"
      />
    </span>
  );
}
